import { render, staticRenderFns } from "./CreateDigiBoardStructure.vue?vue&type=template&id=fd386596&scoped=true"
import script from "./CreateDigiBoardStructure.vue?vue&type=script&lang=js"
export * from "./CreateDigiBoardStructure.vue?vue&type=script&lang=js"
import style0 from "./CreateDigiBoardStructure.vue?vue&type=style&index=0&id=fd386596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd386596",
  null
  
)

export default component.exports